import RenewalEntryCtrl from '../entry/RenewalEntryCtrl';
import RenewalEntryView from 'text!gw-portals-policytransaction-common-angular/transactionEntry/transactionEntry.html';

export default function () {

    const parentState = 'root';

    return {
        renewalTransactionEntry: {
            parent: parentState,
            url: '/renewalTransaction/{selectedPolicyNumber}?day&month&year',
            controller: RenewalEntryCtrl,
            template: RenewalEntryView,
            params: {
                selectedPolicyNumber: null,
                selectedRenewal: null,
                resume: true
            }
        }
    };

}